import { render, staticRenderFns } from "./Arca.vue?vue&type=template&id=1499d942"
import script from "./Arca.vue?vue&type=script&lang=js"
export * from "./Arca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports